import React from "react";
import ReactEcharts from "echarts-for-react"
import { useState, useEffect, useRef } from "react";
import { getMetadata } from '../../services/MetadataService';
import { getTickerIndicatorHistoricals } from "../../services/TickerIndicatorHistoricalService";
import { useParams } from "react-router-dom";

const TickerIndicatorHistorical = ({param}) => {

    const chartRef1 = useRef(null);
    const chartRef2 = useRef(null);

    const [ultoscrsitvss, setUltoscrsitvss] = useState([]);
    const [seriesdata1  , setSeriesdata1] = useState([]);
    const [seriesdata2  , setSeriesdata2] = useState([]);
    const [seriesdata3  , setSeriesdata3] = useState([]);

    const [value, setValue] = useState('')
    var { name } = useParams();
    name = "dukas.graphs"

    useEffect(() => {
        const interval = setInterval(() => { getTickerIndicatorHistoricalsData(); setTickerIndicatorHisticals(); listMetadata(); }, 1000);
        const chartInstance1 = chartRef1.current.getEchartsInstance();
        const chartInstance2 = chartRef2.current.getEchartsInstance();

        // update the charts
        chartInstance1.setOption({
            series: [
                { data: seriesdata1 },
                { data: seriesdata2 }
            ]
        });

        chartInstance2.setOption({
            series: [
                { data: seriesdata3 },

            ]
        });

        return () => { clearInterval(interval); }
    });

    function listMetadata() {
        getMetadata(name).then((response) => {
            // console.log(response.data)
            setValue(response.data.value)
        }).catch(error => {
            console.log(error);
        })
    }

    function getTickerIndicatorHistoricalsData() {
        getTickerIndicatorHistoricals(param).then((response) => {
            setUltoscrsitvss(response.data);
        }).catch(error => {
            console.log(error);
        })
    }

    function setTickerIndicatorHisticals() {
        var data1 = []; var data2 = [];  var data3 = [];

        for (let i = 0; i < ultoscrsitvss.length; i++) {
              data1.push(ultoscrsitvss[i].ultOsc.toFixed(4));
              data2.push(ultoscrsitvss[i].rsi.toFixed(4));
              data3.push(ultoscrsitvss[i].tvs.toFixed(4));
        }

        setSeriesdata1(data1);
        setSeriesdata2(data2);
        setSeriesdata3(data3);
    }

    function showDukasgraphs(style) {
        if (style === "width"  && value === "true") return "920px";
        if (style === "height" && value === "true") return "180px";
        return "0px";
    }

    const [options1] = useState({

        title: {    display: true,
                    text: "", // PrTr Price x Trange
                    textStyle: {
                    fontFamily: 'Arial',
                    fontSize: 13,
                    fontWeight: 'normal',
                    opacity: 1.0,
            },
            align: 'center',
            position: 'bottom',
            padding: {
                top: 0,
                bottom: 0
            }
        },

        tooltip: {
            trigger: "axis",
            axisPointer: {
                type: "shadow",
            },
        },
        legend: {show: false},
        yAxis: {
            type: "value",
            boundaryGap: [0, 0.01],
        },
        xAxis: {
            type: "category",
            data: [],
        },
        series: [
            {
                name: "UltOsc",
                type: "line",
                data: seriesdata1,
                showSymbol: false,
                smooth: false,
            },
            {
                name: "Rsi",
                type: "line",
                data: seriesdata2,
                showSymbol: false,
                smooth: false,
            },

        ],
        grid: {
            top: 30,
            bottom: 10,
            left: 0,
            right: 0,
        }
    });

    const [options2] = useState({

        title: {    display: true,
                    text: "", // PrTr Price x Trange
                    textStyle: {
                    fontFamily: 'Arial',
                    fontSize: 13,
                    fontWeight: 'normal',
                    opacity: 1.0,
            },
            align: 'center',
            position: 'bottom',
            padding: {
                top: 0,
                bottom: 0
            }
        },

        tooltip: {
            trigger: "axis",
            axisPointer: {
                type: "shadow",
            },
        },
        legend: {show: false},
        yAxis: {
            type: "value",
            boundaryGap: [0, 0.01],
        },
        xAxis: {
            type: "category",
            data: [],
        },
        series: [
            {
                name: "Tvs",
                type: "bar",
                showBackground: false,
                data: [],
                itemStyle: {
                    color: function (params) {   // Customize color based on the index
                        // const colors = ['#d82518bb' ];
                        // return colors[params.dataIndex];
                        return params.value >= 0 ? '#008080' : '#FF9966'
                    }
                },
                showSymbol: false,
                smooth: true,
            },
        ],
        grid: {
            top: 30,
            bottom: 0,
            left: 0,
            right: 0,
        }
    });

    return (
        <>
            <ReactEcharts
                ref={chartRef1}
                option={options1}
                style={{ width: showDukasgraphs("width"), height: showDukasgraphs("height") }}>
            </ReactEcharts>
            <ReactEcharts
                ref={chartRef2}
                option={options2}
                style={{ width: showDukasgraphs("width"), height: showDukasgraphs("height") }}>
            </ReactEcharts>
        </>
    )
}

export default TickerIndicatorHistorical;
